/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BrandLinkDto } from './BrandLinkDto';
import {
    BrandLinkDtoFromJSON,
    BrandLinkDtoFromJSONTyped,
    BrandLinkDtoToJSON,
} from './BrandLinkDto';

/**
 * 
 * @export
 * @interface BrandLinksResponse
 */
export interface BrandLinksResponse {
    /**
     * 
     * @type {Array<BrandLinkDto>}
     * @memberof BrandLinksResponse
     */
    links?: Array<BrandLinkDto>;
}

/**
 * Check if a given object implements the BrandLinksResponse interface.
 */
export function instanceOfBrandLinksResponse(value: object): boolean {
    return true;
}

export function BrandLinksResponseFromJSON(json: any): BrandLinksResponse {
    return BrandLinksResponseFromJSONTyped(json, false);
}

export function BrandLinksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandLinksResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'links': json['links'] == null ? undefined : ((json['links'] as Array<any>).map(BrandLinkDtoFromJSON)),
    };
}

export function BrandLinksResponseToJSON(value?: BrandLinksResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'links': value['links'] == null ? undefined : ((value['links'] as Array<any>).map(BrandLinkDtoToJSON)),
    };
}

